import { injectable } from 'tsyringe';
import { IAIUsageProviderToken } from '@bmai/shared';
import { IntegrationsPageViewModel } from './IntegrationsPageViewModel';
import { IntegrationsService } from './IntegrationsService';

@injectable()
export class AiProvidersPageViewModel extends IntegrationsPageViewModel {
    constructor(service: IntegrationsService) {
        super(service, IAIUsageProviderToken);
    }
}
